import { useQuery } from "@tanstack/react-query"
import { getBackofficeCustomersQuery } from "modules/backoffice/lib/customers/getBackofficeCustomersQuery"

export function useGetBackofficeCustomersQuery(
  ...args: Parameters<typeof getBackofficeCustomersQuery>
) {
  return useQuery(getBackofficeCustomersQuery(...args))
}
